export const INVOICE_TABLE = [
    {
        Header: 'Invoice',
        accessor: 'invoice',
    },
    {
        Header: 'თარიღი',
        accessor: 'date',
    },
    {
        Header: 'ჯამი',
        accessor: 'get_total',
    },
    {
        Header: 'სტატუსი',
        accessor: 'status',
    },
];

export const INVOICE_ITEMS_TABLE = [
    {
        Header: 'შტრიხკოდი',
        accessor: 'product_ID',
    },
    {
        Header: 'მარაგი',
        accessor: 'qty_in_wh',
    },
    {
        Header: 'რაოდენობა',
        accessor: 'quantity',
    },
    {
        Header: 'ფასი',
        accessor: 'price',
    },
    {
        Header: 'სულ',
        accessor: 'total',
    },
    {
        Header: 'სტატუსი',
        accessor: 'status',
    },
    {
        Header: 'სურათი',
        accessor: 'image_url',
    },
];
